<script>

  import { email, required, sameAs } from 'vuelidate/lib/validators'
  import DropdownOptions from '@/components/DropdownOptions'

  const initialFormState = {
    name: '',
    email: '',
    phone_number: '',
    role: '',
    roleOther: '',
    school: '',
    question_type: '',
    questionTypeOther: '',
    question_text: '',
    terms: false
  }

  // Notes: optionsRole and optionsQuestionType
  // are incosistent, some refactoring for the logic
  // would be recommended

  export default {
    components: {
      DropdownOptions
    },
    data () {
      return {
        optionsRole: [
          {
            id: 'leerling',
            name: 'Leerling'
          },
          {
            id: 'leraar',
            name: 'Leraar'
          },
          {
            id: 'ouder',
            name: 'Ouder'
          },
          {
            id: 'anders',
            name: 'Anders, namelijk:'
          }
        ],
        optionsQuestionType: [
          {
            id: 0,
            name: 'Ik heb een vraag over een boek.'
          },
          {
            id: 1,
            name: 'Ik wil een (grote) bestelling doen.'
          },
          {
            id: 2,
            name: 'Ik wil graag in contact komen met het Examenbundel-team.'
          },
          {
            id: 3,
            name: 'Ik wil een melding maken over inhoud van een boek.'
          },
          {
            id: 4,
            name: 'Ik heb een vraag over een bestelling (vermeld je ordernummer).'
          },
          {
            id: 5,
            name: 'Anders, namelijk:'
          }
        ],
        form: { ...initialFormState },
        serverErrorMessage: '',
        serverErrors: {},
        loading: false
      }
    },
    validations () {
      return {
        form: {
          name: { required },
          email: { required, email },
          role: !this.otherRoleSelected ? { required } : {},
          roleOther: this.otherRoleSelected ? { required } : {},
          question_type: !this.otherQuestionTypeSelected ? { required } : {},
          questionTypeOther: this.otherQuestionTypeSelected ? { required } : {},
          question_text: { required },
          terms: { checkboxRequired: sameAs(() => true) }
        }
      }
    },
    computed: {
      selectedRole () {
        const option = this.optionsRole.find(option => option.id === this.form.role)
        return option && option.id ? option.id : ''
      },
      selectedQuestionType () {
        const option = this.optionsQuestionType.find(option => option.name === this.form.question_type)
        return option && option.id ? option.id : ''
      },
      // not the nicest way, but otherwise it would need too much refactoring
      otherRoleSelected () {
        return this.form.role === 'anders'
      },
      otherQuestionTypeSelected () {
        return this.form.question_type === 'Anders, namelijk:'
      }
    },
    methods: {
      setRole (id) {
        this.form.role = this.optionsRole.find(option => option.id === id).id
      },
      setQuestionType (id) {
        this.form.question_type = this.optionsQuestionType.find(option => option.id === id).name
      },
      validForm () {
        this.serverErrorMessage = ''
        this.serverErrors = {}
        this.$v.$touch()
        return !this.$v.form.$error
      },
      handleSubmit () {
        const { terms, roleOther, questionTypeOther, ...rest } = this.form
        const formData = { ...rest }
        if (this.otherRoleSelected) formData.role = roleOther
        if (this.otherQuestionTypeSelected) formData.question_type = questionTypeOther
        if (!this.validForm()) return false
        this.loading = true
        this.$store.dispatch('submitContactForm', formData)
          .then(() => {
            this.form = { ...initialFormState }
            this.$v.$reset()
          })
          .catch((err) => {
            this.serverErrorMessage = err.response.data.message || ''
            this.serverErrors = err.response.data.errors || {}
          })
          .finally(() => { this.loading = false })
      }
    }
  }

</script>

<template>
  <form-wrapper
    :validation="$v.form"
    :server-errors="serverErrors"
  >
    <form
      class="form form-contact"
      @submit.prevent="handleSubmit"
    >
      <form-group name="name">
        <e-input
          id="name"
          label="Naam"
          placeholder="Naam"
          :value="form.name"
          @input="form.name = $event"
        />
      </form-group>
      <form-group name="email">
        <e-input
          id="email"
          label="E-mailadres"
          placeholder="E-mailadres"
          :value="form.email"
          class="mt-6"
          @input="form.email = $event"
        />
      </form-group>
      <form-group name="phone_number">
        <e-input
          id="phone_number"
          label="Telefoonnummer (optioneel)"
          placeholder="Telefoonnummer"
          :value="form.phone_number"
          class="mt-6"
          @input="form.phone_number = $event"
        />
      </form-group>
      <form-group name="role">
        <dropdown-options
          id="role"
          label="Ik ben een..."
          class="w-full mt-6"
          :options="optionsRole"
          :selected-option="selectedRole"
          @onSelect="setRole"
        />
      </form-group>
      <form-group
        v-show="form.role === 'anders'"
        name="roleOther"
      >
        <e-input
          id="roleOther"
          label="Functie:"
          placeholder="Anders"
          :value="form.roleOther"
          class="mt-6"
          @input="form.roleOther = $event"
        />
      </form-group>
      <form-group name="school">
        <e-input
          id="school"
          label="School (optioneel)"
          placeholder="School"
          :value="form.school"
          class="mt-6"
          @input="form.school = $event"
        />
      </form-group>
      <form-group name="question_type">
        <dropdown-options
          id="question_type"
          label="Type vraag"
          class="w-full mt-6"
          :options="optionsQuestionType"
          :selected-option="selectedQuestionType"
          @onSelect="setQuestionType"
        />
      </form-group>
      <form-group
        v-show="form.question_type === 'Anders, namelijk:'"
        name="questionTypeOther"
      >
        <e-input
          id="questionTypeOther"
          label="Onderwerp vraag:"
          placeholder="Anders"
          :value="form.questionTypeOther"
          class="mt-6"
          @input="form.questionTypeOther = $event"
        />
      </form-group>
      <form-group name="question_text">
        <e-text-area
          id="question_text"
          label="Je bericht"
          placeholder="Je bericht"
          :value="form.question_text"
          class="mt-6"
          @input="form.question_text = $event"
        />
      </form-group>
      <div class="mt-6">
        <form-group name="terms">
          <div class="flex items-center">
            <e-checkbox
              id="terms"
              v-model="form.terms"
            />
            <p>
              Ik ga akkoord met de <a
                href="https://www.thiememeulenhoff.nl/algemene-voorwaarden"
                target="_blank"
                class="underline"
              >algemene voorwaarden</a> van ThiemeMeulenhoff
            </p>
          </div>
        </form-group>
      </div>
      <div class="flex justify-center w-full mt-12">
        <e-button-loading
          type="submit"
          value="Submit"
          :loading="loading"
        >
          Verzend bericht
        </e-button-loading>
      </div>
    </form>
  </form-wrapper>
</template>

<style lang="scss">
  .form-contact {

    textarea {
      height: 12rem;
    }

  }
</style>
